var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"request-password-reset-btn"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":_vm.requestPasswordResetConfirm}},[_vm._v("\n    "+_vm._s(_vm.buttonStr)+"\n\n    "),(_vm.loaders.sendingPasswordResetEmail)?_c('spinner',{attrs:{"size":"small"}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d94fe3ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestPasswordResetButton.vue
// module id = 1286
// module chunks = 1